import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import HeroStyles from './Hero.styled';

const Hero = ({ heroImage, mobileHeroImage, heroText, pageTitle }) => {
  let heroImageRendered = null;
  let mobileHeroImageRendered = null;

  useEffect(() => {
    function setTabWistiaPlayBtn() {
      let checkWistiaPlayBtn = document.getElementsByClassName(
        'w-css-reset w-vulcan-v2-button'
      );

      // HTMLCollection does not have forEach. Can us aaray.from and then do forEach.
      Array.from(checkWistiaPlayBtn).forEach((btn) => {
        btn.tabIndex = -1;
      });
    }
    window.addEventListener('load', setTabWistiaPlayBtn);
    return () => window.removeEventListener('load', setTabWistiaPlayBtn);
  }, []);

  useEffect(() => {
    if (
      typeof Wistia === 'undefined' &&
      (heroImage[0]?.mediaType === 'Video' ||
        mobileHeroImage[0]?.mediaType === 'Video')
    ) {
      const script = document.createElement('script');

      script.src = 'https://fast.wistia.com/assets/external/E-v1.js';

      document.body.appendChild(script);
    }
  }, [heroImage]);

  if (heroImage) {
    heroImageRendered =
      heroImage[0]?.mediaType === 'Video' ? (
        <>
          <div
            tabIndex="-1"
            className={`wistia_embed wistia_async_${heroImage[0]?.embeddedContent} hero-image-desktop videoFoam=false fakeFullscreen=true autoPlay=true silentAutoPlay=allow muted=true endVideoBehavior=loop playbar=false playButton=false smallPlayButton=false volumeControl=false settingsControl=false share=false fullscreenButton=false fitStrategy=cover playSuspendedOffScreen=false googleAnalytics=false`}
            suppressHydrationWarning={true}
          ></div>
        </>
      ) : heroImage[0]?.mediaType === 'Image' ? (
        <div className="hero-image-desktop">
          <Image src={heroImage[0]?.embeddedImage?.file?.url} fill />
        </div>
      ) : null;
  }

  if (mobileHeroImage) {
    mobileHeroImageRendered =
      mobileHeroImage[0]?.mediaType === 'Video' ? (
        <>
          <div
            tabIndex="-1"
            className={`wistia_embed wistia_async_${mobileHeroImage[0]?.embeddedContent} hero-image-mobile videoFoam=false fakeFullscreen=true autoPlay=true silentAutoPlay=allow muted=true endVideoBehavior=loop playbar=false playButton=false smallPlayButton=false volumeControl=false settingsControl=false share=false fullscreenButton=false fitStrategy=cover playSuspendedOffScreen=false googleAnalytics=false`}
            suppressHydrationWarning={true}
          ></div>
        </>
      ) : mobileHeroImage[0]?.mediaType === 'Image' ? (
        <div className="hero-image-mobile">
          <Image src={mobileHeroImage[0]?.embeddedImage?.file?.url} fill />
        </div>
      ) : null;
  }

  const rendered =
    pageTitle && heroText ? (
      <div className="hero-container">
        {pageTitle && <h1>{pageTitle}</h1>}
        {heroText && <p>{heroText}</p>}
      </div>
    ) : null;

  return (
    <HeroStyles>
      <div className="inner">
        {heroImageRendered}
        {mobileHeroImageRendered}
        <div className="text-wrapper">{rendered}</div>
      </div>
    </HeroStyles>
  );
};

export default Hero;

Hero.propTypes = {
  heroImage: PropTypes.array,
  mobileHeroImage: PropTypes.object,
  heroText: PropTypes.string,
  pageTitle: PropTypes.string,
};
